import { ReactNode } from "react";

export function ILoqLogoSmall({ color }: { color: string }): ReactNode {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none">
      <path
        d="M18.7642 17.2302C20.1389 15.4286 20.9528 13.1876 20.9528 10.7489C20.9528 7.35448 19.3691 4.33354 16.8945 2.36719L14.5409 6.10216C15.7837 7.2666 16.5646 8.91438 16.5646 10.7489C16.5646 14.2862 13.6721 17.1533 10.1087 17.1533C9.30585 17.1533 8.54698 16.9995 7.83211 16.7359L5.47852 20.4599C6.88627 21.119 8.448 21.4925 10.0977 21.4925H10.1087L10.0977 21.5035H22.3496L24.6592 17.8344L25.0001 17.2192H18.7642V17.2302Z"
        fill={color}
      />
      <path
        d="M15.5733 1.58754C14.1435 0.895468 12.5378 0.5 10.8441 0.5C4.86115 0.5 0 5.31153 0 11.2545C0 14.6929 1.62772 17.7468 4.15727 19.7132L6.49986 15.9892C5.20209 14.8138 4.38823 13.133 4.38823 11.2545C4.38823 7.7173 7.28073 4.85015 10.8441 4.85015C11.691 4.85015 12.4938 5.01493 13.2307 5.31153L15.5733 1.58754Z"
        fill={color}
      />
    </svg>
  );
}
